import Grid from '@mui/material/Grid';
import AppAnimate from 'main/core/AppAnimate';
import AppGridContainer from 'main/core/AppGridContainer';
import AppLoader from 'main/core/AppLoader';
import {notEmpty} from 'main/utility/CommonUtil';
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {onGetQuickLinks} from 'redux/actions';
import LayoutTitle from '../UiWiseLayout/LayoutTitle';
import QuickLinkCard from './QuickLinkCard';

const Dashboard = () => {
  const dispatch = useDispatch();
  const quickLinks = useSelector(({commonReducer}) => commonReducer.quickLinks);
  const isLoaded = notEmpty(quickLinks);

  useEffect(() => {
    // Only fetch if we don't have them yet
    if (!isLoaded) {
      dispatch(onGetQuickLinks());
    }
  }, [dispatch]);

  if (!isLoaded) {
    return <AppLoader />;
  }

  return (
    <>
      <LayoutTitle title='Quick Links' />
      <AppAnimate animation='transition.slideUpIn' delay={200}>
        <AppGridContainer>
          <Grid item xs={12}>
            <Grid container spacing={{xs: 4, md: 8}}>
              {quickLinks.map((data, index) => (
                <Grid item xs={12} sm={3} key={index}>
                  <QuickLinkCard data={data} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </AppGridContainer>
      </AppAnimate>
    </>
  );
};

export default Dashboard;
